import { Typenames } from '@varo/graphql-schema-types';
import { Href, Redirect } from 'expo-router';
import useExternalsCards from 'features/myVaro/screens/ExternalAccounts/hooks/useExternalsCards';
import React from 'react';
import FullScreenLoading from 'shared/components/vxl/loading/FullScreenLoading/FullScreenLoading';
import ErrorScreen from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';

type DebitCardFundingSource =
  'move-money' | 'onboarding' | 'progress-tracker-funding';

interface DebitCardFundingScreenProps {
  source?: DebitCardFundingSource;
}

const DebitCardFundingScreen = ({
  source = 'move-money',
}: DebitCardFundingScreenProps) => {
  const { externalCards, fetching, errorModel } = useExternalsCards();

  if (!fetching) {
    const hasLinkedCard =
      externalCards?.__typename === Typenames.ExternalCardsSuccess &&
      externalCards.externalCard.length > 0;
    const tabapayRoute: Href = (
      hasLinkedCard
        ? `/${source}/tabapay/tabapay-transfer-screen`
        : `/${source}/tabapay/dcf-tabapay-form?tabaPayEntryFlowType=DCF`
    ) as Href;
    return <Redirect href={tabapayRoute} />;
  }

  return (
    <ScreenTransitionOverlay
      isLoading={fetching}
      LoadingComponent={<FullScreenLoading isCoinLoader />}
      ErrorComponent={errorModel ? <ErrorScreen {...errorModel} /> : null}
    />
  );
};

export default DebitCardFundingScreen;
